/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createNull } from '../../factoriesAny.js';
export var nullDependencies = {
  createNull
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesNull.generated.js
// module id = 1426
// module chunks = 2